import { SelectedAssetsInfo } from 'widgets/create-card-modal/interfaces';

export const getIsDisabledSave = (selectedAssetsInfo: SelectedAssetsInfo) =>
	!selectedAssetsInfo.selectedBodies.length ||
	!selectedAssetsInfo.selectedClothes.length ||
	!selectedAssetsInfo.selectedHairs.length;
